import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "een_access_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const authHeaders = () => (getToken() ? { Authorization: `Bearer ${getToken()}` } : {});

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/")) {
      setToken(null);
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const RAYG = (v) => (v >= 75 ? "#22C55E" : v >= 60 ? "#FDE047" : v >= 40 ? "#F59E0B" : "#EF4444");
export const RAYG_TEXT = (v) => (v >= 60 && v < 75 ? "#0A0A0A" : v >= 40 && v < 60 ? "#0A0A0A" : "#FFFFFF");
export const RAYG_LABEL = (v) => (v >= 75 ? "Green" : v >= 60 ? "Yellow" : v >= 40 ? "Amber" : "Red");

export const CLASSIFICATIONS = {
  eliminate: { label: "Eliminate", color: "#EF4444" },
  simplify: { label: "Simplify", color: "#F97316" },
  standardise: { label: "Standardise", color: "#EAB308" },
  centralise: { label: "Centralise", color: "#14B8A6" },
  automate: { label: "Automate", color: "#3B82F6" },
  ai_augment: { label: "AI Augment", color: "#A855F7" },
  ai_agent: { label: "AI Agent-led", color: "#6366F1" },
  redesign: { label: "Redesign", color: "#EC4899" },
  human_led: { label: "Human-led", color: "#22C55E" },
};

export const EVIDENCE = {
  validated: { label: "Validated", color: "#22C55E" },
  user_reported: { label: "User-reported", color: "#3B82F6" },
  ai_inference: { label: "AI inference", color: "#A855F7" },
  assumption: { label: "Assumption", color: "#F59E0B" },
  industry_reference: { label: "Industry reference", color: "#14B8A6" },
};

export const SCORE_DIMS = [
  ["strategic_alignment", "Strategic alignment"], ["customer_value", "Customer value"],
  ["process_health", "Process health"], ["role_clarity", "Role clarity"],
  ["workforce_capability", "Workforce capability"], ["data_readiness", "Data readiness"],
  ["technology_readiness", "Technology readiness"], ["ai_readiness", "AI readiness"],
  ["governance_maturity", "Governance maturity"], ["integration_maturity", "Integration maturity"],
  ["change_readiness", "Change readiness"], ["value_potential", "Value potential"],
];

export const PHASES = ["Discover", "Prioritise", "Design", "Pilot", "Scale", "Optimise"];

export const INIT_TYPES = {
  quick_win: { label: "Quick win", color: "#22C55E" },
  foundational: { label: "Foundational", color: "#3B82F6" },
  strategic_bet: { label: "Strategic bet", color: "#A855F7" },
  regulatory: { label: "Regulatory", color: "#EF4444" },
};

export const OUTCOMES = [
  "Customer value and experience", "Growth and revenue", "Operational efficiency",
  "Risk and resilience", "Innovation and speed", "Employee experience and capability",
  "Social, regulatory or sustainability outcomes",
];

export const DIMENSIONS = [
  { key: "strategy", label: "Strategy", color: "#D4AF37", desc: "Priorities, value proposition, measures, investment choices" },
  { key: "process", label: "Process", color: "#3B82F6", desc: "Value streams, workflows, hand-offs, bottlenecks, cycle time" },
  { key: "people", label: "People", color: "#22C55E", desc: "Structure, roles, skills, capacity, change impact" },
  { key: "data", label: "Data", color: "#6366F1", desc: "Domains, ownership, lineage, quality, decision rights" },
  { key: "technology", label: "Technology", color: "#A855F7", desc: "Applications, integrations, automation, AI agents" },
  { key: "governance", label: "Governance", color: "#EF4444", desc: "Decision rights, controls, risk, ethics, assurance" },
];
